/* Köztes ajánlati oldal.

   Az ártábla gombjai egyenesen a pénztárra vinnének
   (/cart/<variáns>:1?return_to=/checkout). Ez a szkript elkapja a kattintást,
   háttérben beteszi a terméket a kosárba, és felhozza a teljes képernyős
   ajánlatot. Ha nincs mit ajánlani, vagy bármi hibázik, a vásárló megy tovább
   a pénztárra — a vásárlás emiatt sosem akadhat el.

   A gombra kattintáskor a kosár előbb kiürül (2026-10-20), ugyanúgy, ahogy a
   Shopify saját /cart/<variáns>:<db> linkje is csak a választott tételt teszi
   a kosárba. Enélkül a pénztárból visszalépő vevő régi tétele bent maradt:
   az "ELÉG CSAK AZ E-BOOK" mellé a korábbi csomag is a pénztárba ment, és az
   ajánlat sem jelent meg újra.

   Elfogadáskor a csomag komponensei kikerülnek a kosárból. Enélkül a vevő
   kétszer fizetne az alaptananyagért: egyszer külön, egyszer a csomagban.
   A sorrend szándékosan "előbb hozzáad, aztán töröl": ha a törlés hibázik,
   a vevő a pénztárnál két tételt lát és korrigálhat, míg fordítva üres
   kosárral maradna.

   Szándékosan nem <dialog>: a téma saját kosárfiókja is az, és a böngésző
   legfelső rétegében két dialógus egymás elé kerülése a Brinutin sok bajt
   okozott. Ez egy sima fix pozíciójú réteg.

   Minden lekérdezés futásidőben történik, és minden figyelő a document-en ül,
   mert a témaszerkesztő szerkesztés közben újrarendereli a szekciót. */
(() => {
  const gyoker = () => document.getElementById('MfkUpsell');

  const getCart = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => {
      if (!r.ok) throw new Error('cart.js');
      return r.json();
    });

  const clearCart = () =>
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
    }).then((r) => {
      if (!r.ok) throw new Error('cart/clear.js');
      return r.json();
    });

  const addToCart = (id, quantity) =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
    }).then((r) => {
      if (!r.ok) throw new Error('cart/add.js');
      return r.json();
    });

  const removeLine = (key) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then((r) => {
      if (!r.ok) throw new Error('cart/change.js');
      return r.json();
    });

  /* A fejléc kosárbuborékja erre az eseményre frissül, lásd assets/cart-icon.js.
     Szándékosan 'cart:update' és nem 'cart:add': utóbbira a téma magától
     kinyitná a kosárfiókot, ami pont az ablak elé úszna. */
  const jelezdAKosarValtozast = (cart) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        detail: { data: { itemCount: cart.item_count, source: 'mfk-upsell' } },
      })
    );
  };

  const komponensIdk = (root) =>
    (root.dataset.componentIds || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

  const penztarCim = (root) => {
    const alap = root.dataset.checkoutUrl || '/checkout';
    const kod = (root.dataset.discountCode || '').trim();
    if (!kod) return alap;
    /* A Shopify így fogadja el a kupont oldalbetöltéskor. */
    return '/discount/' + encodeURIComponent(kod) + '?redirect=' + encodeURIComponent(alap);
  };

  let elozoFokusz = null;

  const nyisd = (root) => {
    elozoFokusz = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    root.scrollTop = 0;
    /* a videó poszterét csak megnyitáskor töltjük be (az oldal betöltését nem lassítja) */
    root.querySelectorAll('video[data-poster]').forEach((v) => { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); });
    /* a videó lejátszáskor teljes képernyőre ugrik (mobilon és asztalon is), Esc-re vagy a bezárás gombbal kilép, és megáll */
    const mobil = window.matchMedia('(max-width: 749px)').matches;
    root.querySelectorAll('video').forEach((v) => {
      if (v.dataset.mfkTeljes) return;
      v.dataset.mfkTeljes = '1';
      if (mobil) v.removeAttribute('playsinline'); /* iPhone: lejátszáskor magától teljes képernyős */
      v.addEventListener('play', () => {
        if (document.fullscreenElement || v.webkitDisplayingFullscreen) return;
        try {
          if (v.requestFullscreen) v.requestFullscreen().catch(() => {});
          else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
        } catch (_) {}
      });
      /* bezáráskor megáll a hang */
      const megall = () => { if (!document.fullscreenElement) v.pause(); };
      document.addEventListener('fullscreenchange', megall);
      v.addEventListener('webkitendfullscreen', () => v.pause());
    });
    const cta = root.querySelector('[data-mfk-accept]');
    /* fókusz görgetés nélkül, és az ablak mindig a tetejéről indul (különben a gombhoz, azaz az aljára ugrott) */
    if (cta) { try { cta.focus({ preventScroll: true }); } catch (_) { cta.focus(); } }
    root.scrollTop = 0;
    requestAnimationFrame(() => { root.scrollTop = 0; });
    setTimeout(() => { root.scrollTop = 0; }, 120);
  };

  /* ── Termék-felugró ──
     Egyetlen panel, a tartalmát a megnyomott doboz adat-attribútumaiból kapja.
     A réteget NEM zárja be: az ajánlat végig ott marad mögötte, csak tompítva. */
  const infoPanel = (root) => root.querySelector('[data-mfk-info-panel]');

  const nyisdAzInfot = (root, gomb) => {
    const panel = infoPanel(root);
    if (!panel) return;

    const kep = panel.querySelector('[data-mfk-info-img]');
    const cim = panel.querySelector('[data-mfk-info-cim]');
    const leiras = panel.querySelector('[data-mfk-info-leiras]');

    const kepUrl = gomb.dataset.kep || '';
    if (kep) {
      kep.src = kepUrl;
      kep.alt = gomb.dataset.cim || '';
      kep.parentElement.hidden = !kepUrl;
    }
    if (cim) cim.textContent = gomb.dataset.cim || '';
    if (leiras) {
      leiras.textContent = gomb.dataset.leiras || '';
      leiras.hidden = !(gomb.dataset.leiras || '').trim();
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    const zar = panel.querySelector('[data-mfk-info-close]');
    if (zar) zar.focus();
  };

  const csukdAzInfot = (root) => {
    const panel = infoPanel(root);
    if (!panel) return false;
    if (!panel.classList.contains('is-open')) return false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    return true;
  };

  const csukd = (root) => {
    csukdAzInfot(root);
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (elozoFokusz && typeof elozoFokusz.focus === 'function') elozoFokusz.focus();
  };

  /* Az ártábla és minden más /cart/<variáns>:<db> alakú vásárlás-link. */
  const CART_LINK = /\/cart\/(\d+):(\d+)/;

  document.addEventListener('click', async (event) => {
    const root = gyoker();

    if (root) {
      const panel = infoPanel(root);

      if (event.target.closest('[data-mfk-info-close]')) {
        event.preventDefault();
        csukdAzInfot(root);
        return;
      }

      /* A panel hátterére kattintás is zár, a dobozon belüli kattintás nem. */
      if (panel && event.target === panel) {
        csukdAzInfot(root);
        return;
      }

      const infoGomb = event.target.closest('[data-mfk-info]');
      if (infoGomb) {
        event.preventDefault();
        nyisdAzInfot(root, infoGomb);
        return;
      }

      if (event.target.closest('[data-mfk-decline]')) {
        event.preventDefault();
        window.location.href = root.dataset.checkoutUrl || '/checkout';
        return;
      }

      const cta = event.target.closest('[data-mfk-accept]');
      if (cta) {
        event.preventDefault();
        if (cta.disabled) return;

        const variansId = root.dataset.offerVariantId;
        if (!variansId) return;

        const felirat = cta.querySelector('.mfk-cta__szoveg') || cta;
        const eredeti = felirat.textContent;

        cta.disabled = true;
        felirat.textContent = cta.dataset.busyLabel || 'Egy pillanat…';
        root.classList.remove('is-error');

        try {
          await addToCart(variansId, 1);

          const komponensek = komponensIdk(root);
          if (komponensek.length) {
            const cart = await getCart();
            const torlendo = cart.items.filter(
              (item) => komponensek.indexOf(String(item.product_id)) !== -1
            );
            for (const item of torlendo) {
              await removeLine(item.key);
            }
          }

          window.location.href = penztarCim(root);
        } catch (_) {
          cta.disabled = false;
          felirat.textContent = eredeti;
          root.classList.add('is-error');
        }
        return;
      }
    }

    const link = event.target.closest('a[href*="/cart/"]');
    if (!link || (root && root.contains(link))) return;

    const talalat = CART_LINK.exec(link.getAttribute('href') || '');
    if (!talalat) return;

    /* Nincs beállítva felkínálható csomag: hagyjuk a linket a maga útján. */
    if (!root || !root.dataset.offerVariantId) return;

    event.preventDefault();

    try {
      /* Mindig csak a most választott tétel legyen a kosárban, mint a
         Shopify permalinknél — lásd a fejléc-megjegyzést. */
      await clearCart();
      await addToCart(talalat[1], Number(talalat[2]) || 1);
      const cart = await getCart();
      jelezdAKosarValtozast(cart);

      const mar_benne = cart.items.some(
        (item) => String(item.product_id) === root.dataset.offerProductId
      );

      if (!mar_benne) {
        nyisd(root);
        return;
      }
      window.location.href = root.dataset.checkoutUrl || '/checkout';
    } catch (_) {
      /* A link szerveroldalon ugyanezt elvégzi, csak lassabban. */
      window.location.href = link.href;
    }
  });

  /* A kedvezményes ár a csomag külön variánsán ül, nem kuponon. Ha nincs
     megadva variáns, a szekció a termék ELSŐ variánsát használja — az viszont
     a normál árú, tehát a vevő némán többet fizetne a gombon ígértnél.
     Kupon helyett most ez a hibalehetőség, ezért erre figyelmeztetünk. */
  {
    const root = gyoker();
    if (root && root.dataset.offerProductId && !root.dataset.offerVariantId) {
      console.warn(
        '[mfk-upsell] Van felkínált csomag, de nincs variáns feloldva — az ablak nem fog megjelenni.'
      );
    }
  }

  /* Megnyitás kézzel, ?upsell=1 paraméterrel. Ez a szerkesztés közbeni
     nézegetésre kell: a szekció "Előnézeti mód" kapcsolója állandóan nyitva
     tartaná a réteget, ami az egész oldalt kitakarja mögötte. */
  if (/[?&]upsell=1\b/.test(window.location.search)) {
    const root = gyoker();
    if (root) nyisd(root);
  }

  /* Escape csak becsukja a réteget — nem visz sehova. A vásárló ilyenkor a
     kosarában lévő termékkel az oldalon marad, ami épp elfogadható kimenet. */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = gyoker();
    if (!root) return;
    /* Ha a termék-felugró nyitva van, azt zárja — a réteget csak utána. */
    if (csukdAzInfot(root)) return;
    if (root.classList.contains('is-open')) csukd(root);
  });
})();
